<template>
  <crud-editor
    ref="editor"
    :definition="definition"
    :is-edit="false"
    :auto-generated-id="false"
    :save="saveData"
    :return-to="returnTo"
    :item-type="entity"
    :get-dependencies="getDependencies"
  />
</template>

<script>
import CrudEditor from '@/components/crud/Editor';
import formMixin from './form-mixin';

export default {
  components: {
    CrudEditor
  },
  mixins: [formMixin],
  methods: {
    saveData(form) {
      const item = this.createItemFromFormData(this, form);
      return this.$store.dispatch(this.entityStore + '/persistItem', item);
    }
  }
};
</script>
